import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { Store } from '@ngrx/store';
import {
  applyMenuFiltersAction,
  changeFavoriteState,
  clearFiltersInit,
} from 'src/app/data/store/actions/filters.actions';
import { FiltersOptionsType, IFiltersOptionsParam } from 'src/app/data/store/models/filters.model';
import { arrowRight, FiltersOptionsNames } from 'src/app/shared/constants';
import {
  Buttons,
  ButtonTextSizes,
  FiltersResetTypes,
  TextSizes,
  TextType,
} from 'src/app/shared/enums';
import { UntilDestroy } from '@ngneat/until-destroy';
import { UtilsService } from '../../../../services/utils.service';
import { TextComponent } from '../../../text/text.component';
import { ButtonComponent } from '../../../button/button.component';
import { IonScrollBarDirective } from '../../../../directives/ion-scroll-bar/ion-scroll-bar.directive';

import { ImageComponent } from '../../../image/image.component';
import { SelectedFiltersComponent } from '../selected-filters/selected-filters.component';

@UntilDestroy()
@Component({
  selector: 'app-filters-menu',
  templateUrl: './filters-menu.component.html',
  styleUrls: ['./filters-menu.component.scss'],
  imports: [
    IonicModule,
    TextComponent,
    ButtonComponent,
    IonScrollBarDirective,
    ImageComponent,
    SelectedFiltersComponent,
  ],
})
export class FiltersMenuComponent {
  private _store = inject(Store);
  private _utils = inject(UtilsService);
  private _modalCtrl: ModalController = inject(ModalController);

  @Input() menuOptions: FiltersOptionsType[] = [];

  @Input() initialFilters: IFiltersOptionsParam | null = null;

  @Input() onlyFavorite?: boolean;

  @Input() withFavoriteOption = false;

  @Input() isFiltersChosen: boolean | null = null;

  @Output() public emitSelectedMenuOption = new EventEmitter();

  readonly TextSizes = TextSizes;

  readonly TextType = TextType;

  readonly Buttons = Buttons;

  readonly ButtonTextSizes = ButtonTextSizes;

  readonly FiltersOptionsNames = FiltersOptionsNames;

  readonly arrowRight = arrowRight;

  public selectFilter(option: FiltersOptionsType) {
    if (this.onlyFavorite) {
      return;
    }
    this.emitSelectedMenuOption.emit(option);
  }

  public favsChange(event: any) {
    this.onlyFavorite = event.detail.checked;

    this._store.dispatch(
      changeFavoriteState({
        favs: event.detail.checked,
      }),
    );
  }

  public clearAllFilters() {
    if (!this.isFiltersChosen) return;

    this._store.dispatch(clearFiltersInit({ clearType: FiltersResetTypes.resetAll }));
  }

  public closeModal() {
    this._utils.dismissModal();
  }

  public applyFilters() {
    this._store.dispatch(applyMenuFiltersAction());
    this._modalCtrl
      .getTop()
      .then((modal) => {
        if (modal) {
          modal.canDismiss = true;
          this._modalCtrl.dismiss();
        }
      })
      .catch(() => {
        // no-op: обработка по умолчанию
      });
  }
}
